import { render, staticRenderFns } from "./DepartementAddNew.vue?vue&type=template&id=1d857cec&"
import script from "./DepartementAddNew.vue?vue&type=script&lang=js&"
export * from "./DepartementAddNew.vue?vue&type=script&lang=js&"
import style0 from "./DepartementAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports